import decryptAES256GCM from '@utils/decryptAES';
import { date, showAlert } from '../../lib/helpers';
import { headers, detailHeaders, search, merchantType, clientType, filterData } from './attributes';
import validationRules from './validationRules';

export default {
  data: () => ({
    options: {},
    filter: {
      created_date: [],
    },
    confirmDialog: false,
    headers,
    detailHeaders,
    search,
    filterData,
    filterValue: { created_date: [], merchant_type: '', mid: '', client_type: '', aggregator_name: '' },
    filterConfig: [
      { key: 'created_date', type: 'daterange', props: { label: 'Tanggal Dibuat', includeToday: true, limitRangeTo30Days: true } },
      { key: 'merchant_type', type: 'select', props: { label: 'Tipe Merchant', items: merchantType } },
      { key: 'mid', type: 'textfield', props: { label: 'MID' } },
      { key: 'aggregator_name', type: 'textfield', props: { label: 'Aggregator Name' } },
      { key: 'client_type', type: 'select', props: { label: 'Versi Client', items: clientType } },
    ],
    dialog: false,
    dialogLoading: false,
    hasGeneratedInSession: false,
    formData: {
      allow_gen_outbound_pair_pem_key: false,
      show_hidden_fields: false,
      mid: '',
      merchant_name: '',
      aggregator_name: '',
      email: '',
      client_type: '',
      client_id: '',
      hidden_inbound_client_id: '',
      hidden_inbound_merchant_secret_key: '',
      outbound_private_key: '',
      outbound_public_key: '',
      callback_url: '',
      callback_partner_id: '',
      callback_partner_secret: '',
      callback_partner_url_token: '',
      inbound_merchant_public_key: '',
    },
    formDataOriginal: {},
    gcmKey: process.env.VUE_APP_GCM_SECRET,
    clientType,
    rules: validationRules,
  }),

  computed: {
    showCredential(){
      return this.isSnap && this.showHiddenFields;
    },
    allowGenerate(){
      return !!this.formData?.allow_gen_outbound_pair_pem_key && !this.hasGeneratedInSession;
    },
    showHiddenFields(){
      return !!this.formData.show_hidden_fields;
    },
    hasAggregator() {
      return !!this.formData.aggregator_name && this.formData.aggregator_name.trim() !== '';
    },
    isSnap() {
      return this.formData.client_type === '2';
    },
    loadingGenerate() {
      return this.$store.state.merchantCallbackManagement.loadingGenerate;
    },
    allData() {
      return this.$store.state.merchantCallbackManagement.allData;
    },
    totalData() {
      return this.$store.state.merchantCallbackManagement.totalData;
    },
    totalPage() {
      return this.$store.state.merchantCallbackManagement.totalPage;
    },
    loading() {
      return this.$store.state.merchantCallbackManagement.loading;
    },
  },
  
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  methods: {
    async openDialog(mode, item) {
      this.dialogMode = mode;
      this.dialog = true;
      this.dialogLoading = true;
      this.hasGeneratedInSession = false;

      try {
        const detail = await this.$store.dispatch(
          'merchantCallbackManagement/getDetail',
          { id: item?.client_id, date }
        );
        const clientTypeValue = detail?.client_type_original || null;
        this.formData.client_type = clientTypeValue;

        if (detail) {
          this.formDataOriginal = { ...detail };

          this.formData = {
            mid: detail?.mid || '',
            merchant_name: detail?.merchant_name || '',
            aggregator_name: detail?.aggregator_name || '',
            email: detail?.email || '',
            client_type: clientTypeValue,
            client_id: detail?.client_id || '',
            allow_gen_outbound_pair_pem_key: detail?.allow_gen_outbound_pair_pem_key || false,
            show_hidden_fields: detail?.show_hidden_fields || false,
            hidden_inbound_client_id: detail?.hidden_inbound_client_id || '',
            hidden_inbound_merchant_secret_key: detail?.hidden_inbound_merchant_secret_key || '',
            outbound_private_key: '',
            outbound_public_key: detail?.hidden_outbound_public_key
              ? decryptAES256GCM(detail?.hidden_outbound_public_key, this.gcmKey)
              : '',
            callback_url: detail?.callback_url || '',
            callback_partner_id: detail?.callback_partner_id || '',
            callback_partner_secret: detail?.callback_partner_secret || '',
            callback_partner_url_token: detail?.callback_partner_url_token || '',
            inbound_merchant_public_key: detail?.inbound_merchant_public_key
              ? decryptAES256GCM(detail?.inbound_merchant_public_key, this.gcmKey)
              : '',
          };
        }
      } catch (err) {
        showAlert(this.$store, 'Failed Fetching Detail', 'mdi-alert', 'red');
      } finally {
        this.dialogLoading = false;
      }
    },
    closeDialog() {
      this.dialog = false;
      this.hasGeneratedInSession = false;
    },
    async saveData() {
      if (this.$refs.form && this.$refs.form.validate && !this.$refs.form.validate()) {
        this.dialogLoading = false;
        return;
      }
      this.confirmDialog = true;
    },

    async handleConfirm() {
      this.confirmDialog = false;
      this.dialogLoading = true;
      const payload = {
        client_id: this.formData.client_id,
        client_type: this.formData.client_type,
        callback_url: this.formData.callback_url,
        callback_partner_id: this.formData.callback_partner_id,
        callback_partner_secret: this.formData.callback_partner_secret,
        callback_partner_url_token: this.formData.callback_partner_url_token,
        inbound_merchant_public_key: this.formData.inbound_merchant_public_key,
        outbound_public_key: this.formData.outbound_public_key,
        outbound_private_key: this.formData.outbound_private_key
      };
      const res = await this.$store.dispatch('merchantCallbackManagement/updateMerchantSnap', { payload, date });
      if (res?.success) {
        this.getData();
        this.dialog = false;
      }
      this.dialogLoading = false;
    },
    async generateSnapKey() {
      if (!this.formData.client_id) return;
      const result = await this.$store.dispatch(
        'merchantCallbackManagement/generateKey',
        { id: this.formData.client_id, date }
      );

      if (result) {
        this.formData.outbound_private_key = decryptAES256GCM(result.private_key , this.gcmKey)|| '';
        this.formData.outbound_public_key = decryptAES256GCM(result.public_key, this.gcmKey) || '';
        this.hasGeneratedInSession = true;

        showAlert(
          this.$store, 
          this.showHiddenFields ? 'Successfully Generated' : 'Credential SNAP Successfully Applied',
          'mdi-check',
          'green'
        );
      }
    },
    updateSearch(newSearch) {
      this.search.created_date = newSearch.created_date || [];
      this.search.merchant_type = newSearch.merchant_type || '';
      this.search.mid = newSearch.mid || '';
      this.search.client_type = newSearch.client_type || '';
      this.search.aggregator_name = newSearch.aggregator_name || '';
      this.options.page = 1;
      this.getData(); 
    },
    showType(newSearch) {
      this.search.created_date = newSearch.created_date || [];
      this.search.merchant_type = newSearch.merchant_type || '';
      this.search.mid = newSearch.mid || '';
      this.search.client_type = newSearch.client_type || '';
      this.search.aggregator_name = newSearch.aggregator_name || '';
      this.options.page = 1;
      this.getData(); 
    },

    getData() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('merchantCallbackManagement/getData', {
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          date
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
      
    },
  
    clearSearch() {
      this.search.merchant_type = '';
      this.search.mid = '';
      this.search.client_type = '';
      this.search.created_date = [];
    },

  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};